// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-wrapper-data-actions {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.menu-wrapper-data-actions .actions-slider-header-menu {
  display: flex;
  align-items: center;
  padding: 14px 15px;
  gap: 10px;
  flex-shrink: 0;
}
.menu-wrapper-data-actions .actions-slider-header-menu .article-menuheader {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 6px;
  overflow: hidden;
}
.menu-wrapper-data-actions .actions-slider-header-menu .article-menuheader h1 {
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.menu-wrapper-data-actions .actions-slider-header-menu .article-menuheader span {
  border-radius: 16px;
  background: var(--sdk-gloabl-bg-secondary);
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}
.menu-wrapper-data-actions .actions-slider-header-menu .title-desc-heading {
  width: 100%;
}
.menu-wrapper-data-actions .actions-slider-header-menu .title-desc-heading p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 4px;
}
.menu-wrapper-data-actions .actions-slider-header-menu h1 {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close {
  width: 16px;
  height: 16px;
  border: 0;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close svg path {
  fill: var(--sdk-gloabl-text-color);
}
.menu-wrapper-data-actions .iner-data-scroll-wraper {
  flex: 1 1 auto;
  overflow: auto;
  padding-bottom: 16px;
}
.menu-wrapper-data-actions .iner-data-scroll-wraper.hidden-scroll {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.menu-wrapper-data-actions .iner-data-scroll-wraper.otp-data-scroll-wrapper {
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/menu/menu.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAAJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AACR;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;AAEZ;AADY;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAGhB;AADY;EACI,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGhB;AAAQ;EACI,WAAA;AAEZ;AADY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAGhB;AAAQ;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AAAQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAEZ;AAAgB;EACI,kCAAA;AAEpB;AAGI;EACI,cAAA;EACA,cAAA;EACA,oBAAA;AADR;AAEQ;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAAZ;AAEQ;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAZ","sourcesContent":["\n.menu-wrapper-data-actions{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    .actions-slider-header-menu{\n        display: flex;\n        align-items: center;\n        padding: 14px 15px;\n        gap: 10px;\n        flex-shrink: 0;\n        .article-menuheader{\n            display: flex;\n            align-items: center;\n            width: 100%;\n            gap: 6px;\n            overflow: hidden;\n            h1{\n                width: auto;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n            span{\n                border-radius: 16px;\n                background: var(--sdk-gloabl-bg-secondary);\n                display: flex;\n                padding: 2px 8px;\n                justify-content: center;\n                align-items: center;\n                flex-shrink: 0;\n                text-align: center;\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 18px;\n            }\n        }\n        .title-desc-heading{\n            width: 100%;\n            p{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 18px;\n                margin-top: 4px;\n            }\n        }\n        h1{\n            width: 100%;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n        }\n        .menu-close{\n            width: 16px;\n            height: 16px;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n    .iner-data-scroll-wraper{\n        flex: 1 1 auto;\n        overflow: auto;\n        padding-bottom: 16px;\n        &.hidden-scroll{\n            display: flex;\n            flex-direction: column;\n            overflow: hidden;\n        }\n        &.otp-data-scroll-wrapper{\n            padding: 0 16px 16px 16px;\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
